import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted, computed} from "vue";
import { PlotData } from "@/components/Impedance";
import Plotly from "plotly.js-dist-min";

interface PlotConfig{
    zeroline: boolean;
}
/* eslint-disable-next-line */

export default /*#__PURE__*/_defineComponent({
  __name: 'BodePlot',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data: PlotData[],
}



let graph_magnitude = ref(null);
let graph_phase = ref(null);

let data_magnitude = computed(()=>{
    let output = [];
    if(props.data){
        for(var i=0; i<props.data.length; ++i){
            let trace = props.data[i];
            if(trace===undefined){
                continue;
            }
            let mag = [];
            let texts = [];
            
            for(var j=0; j<trace.f.length; ++j){
                mag.push(Math.sqrt(trace.rs[j]**2 + trace.x[j]**2));
                texts.push(`Rs: ${trace.rs[j].toFixed(3)}, X: ${trace.x[j].toFixed(3)}`);
            }

            output.push({
                x: trace.f,
                y: mag,
                text: texts,
                name: trace.name,
                mode: "lines",
                type: "scatter"
            });

            if(trace.f_calc && trace.rs_calc && trace.x_calc){
                let mag_calc = [];
                let texts_calc = [];
                for(var k=0; k<trace.f_calc.length; ++k){
                    mag_calc.push(Math.sqrt(trace.rs_calc[k]**2 + trace.x_calc[k]**2));
                    texts_calc.push(`Rs: ${trace.rs_calc[k].toFixed(3)}, X: ${trace.x_calc[k].toFixed(3)}`);
                }
                output.push({
                    x: trace.f_calc,
                    y: mag_calc,
                    text: texts_calc,
                    name: trace.name + " (fitting)",
                    mode: "markers",
                    type: "scatter"
                });
            }
        }
    }
    return output as Plotly.Data; 
});
let data_phase = computed(()=>{
    let output = [];
    if(props.data){
        for(var i=0; i<props.data.length; ++i){
            let trace = props.data[i];
            if(trace===undefined){
                continue;
            }
            let phase = [];
            let texts = [];
            
            for(var j=0; j<trace.f.length; ++j){
                phase.push(Math.atan2(trace.x[j],trace.rs[j]) * 180 / Math.PI);
                texts.push(`Rs: ${trace.rs[j].toFixed(3)}, X: ${trace.x[j].toFixed(3)}`);
            }

            output.push({
                x: trace.f,
                y: phase,
                text: texts,
                name: trace.name,
                mode: "lines",
                type: "scatter"
            });

            if(trace.f_calc && trace.rs_calc && trace.x_calc){
                let phase_calc = [];
                let texts_calc = [];
                for(var k=0; k<trace.f_calc.length; ++k){
                    phase_calc.push(Math.atan2(trace.x_calc[k], trace.rs_calc[k]) * 180 / Math.PI);
                    texts_calc.push(`Rs: ${trace.rs_calc[k].toFixed(3)}, X: ${trace.x_calc[k].toFixed(3)}`);
                }
                output.push({
                    x: trace.f_calc,
                    y: phase_calc,
                    text: texts_calc,
                    name: trace.name + " (fitting)",
                    mode: "markers",
                    type: "scatter"
                });
            }
        }
    }
    return output as Plotly.Data; 
});

const updateGraph = (graph: any, data: Plotly.Data, oldval: any)=>{
    if(!graph){
        return;
    }
    return Plotly.react(graph, oldval, graph.layout).then(()=>{
        return Plotly.update(
        graph,
        data,
        graph.layout)
    }).then(()=>{
        return Plotly.animate(
            graph,
            {
                data: data
            },
            {
                transition: {
                    duration: 200,
                    easing: 'cubic-in-out'
                },
                frame:{
                    duration: 200
                }
            }
        )
    }).then(()=>{
        return Plotly.animate(
            graph, 
            {
                layout:{
                    'xaxis.autorange': true,
                    'yaxis.autorange': true,
                }
            },
            {
                transition: {
                    duration: 200,
                    easing: 'cubic-in-out'
                },
                frame:{
                    duration: 200
                }
            }
        );
    }).catch((e)=>{
        //do nothing
    });
}

watch(data_magnitude, (_, oldval)=>{
    updateGraph(graph_magnitude.value, data_magnitude.value, oldval);
});
watch(data_phase, (_, oldval)=>{
    updateGraph(graph_phase.value, data_phase.value, oldval);
});

onMounted(()=>{
    //define default layout
    let layout1 = {
        automargin: true,
        autosize: true,
        xaxis: {
            type: "log",
            autorange: true,
            zeroline: true,
            title: "frequency (Hz)"
        },
        yaxis: {
            type: "log",
            autorange: true,
            zeroline: true,
            title: "|Z| (ohm)"
        },
        legend: {
            x: 1,
            xanchor: 'right',
            y: 1
        }
    };
    let layout2 = {
        automargin: true,
        autosize: true,
        xaxis: {
            type: "log",
            autorange: true,
            zeroline: true,
            title: "frequency (Hz)"
        },
        yaxis: {
            autorange: true,
            zeroline: true,
            title: "Argument (degree)"
        },
        legend: {
            x: 1,
            xanchor: 'right',
            y: 1
        }
    };

    let config = {
        responsive: true
    };

    Plotly.newPlot(graph_magnitude.value, data_magnitude.value, layout1, config);
    Plotly.newPlot(graph_phase.value, data_phase.value, layout2, config);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "graph_magnitude",
      ref: graph_magnitude
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "graph_phase",
      ref: graph_phase
    }, null, 512)
  ]))
}
}

})